// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9c5babe","407":"9e5fc250","494":"c4c1f016","496":"9ba48a6d","725":"8ad10d09"}[chunkId] + ".chunk.js";
};